export enum LanguageEndpoints {
  FetchLanguages = '/languages',
  FetchLanguageLevels = '/language-levels',
}
